import { AError } from "../../../../requests/types";
import { REQUEST_ISADMIN, ISADMIN_SUCCESS, ISADMIN_ERROR } from "../../actions";

// ----- REQUEST ----------------------------------------------------------
type RequestIsAdmin = {
  type: typeof REQUEST_ISADMIN;
};

export const requestIsAdmin = (): RequestIsAdmin => ({
  type: REQUEST_ISADMIN,
});

// ----- SUCCESS ---------------------------------------------------------
type SuccessIsAdmin = {
  type: typeof ISADMIN_SUCCESS;
  payload: {
    data: boolean;
  };
};

export const successIsAdmin = (data: boolean): SuccessIsAdmin => ({
  type: ISADMIN_SUCCESS,
  payload: { data },
});

// ----- ERROR -----------------------------------------------------------
type ErrorIsAdmin = {
  type: typeof ISADMIN_ERROR;
  error: { error: AError };
};

export const errorIsAdmin = (error: AError): ErrorIsAdmin => ({
  type: ISADMIN_ERROR,
  error: { error },
});

export type IsAdminActions = RequestIsAdmin | SuccessIsAdmin | ErrorIsAdmin;
